"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiActions = void 0;
var ApiActions;
(function (ApiActions) {
    ApiActions["FDP_STORAGE"] = "fdp-storage";
    ApiActions["SIGNER_SIGN_MESSAGE"] = "signer.signMessage";
    ApiActions["SEND_TRANSACTION"] = "send-transaction";
    ApiActions["GET_USER_BALANCE"] = "get-user-balance";
    ApiActions["GET_USER_INFO"] = "get-user-info";
    ApiActions["ECHO"] = "echo";
})(ApiActions = exports.ApiActions || (exports.ApiActions = {}));
